import { jsx } from 'react/jsx-runtime';
import { styled } from 'styled-components';
import { IconGlobe } from '@fabric-app/icons/svg';
import { cssVar } from '@fabric-app/ui/theme/variables';
import Tooltip from '@fabric-app/ui/components/Tooltip';

const ShareIconWrapper = styled.div.withConfig({
  displayName: "IconSharedWithPublic__ShareIconWrapper",
  componentId: "sc-d011d31b-0"
})([
  `color:`,
  `;height:1.125rem;width:1.125rem;border-radius:50%;display:flex;justify-content:center;align-items:center;background:rgba(`,
  `,0.13);flex-shrink:0;`
], cssVar["color-text-tertiary"], cssVar["color-bg-primary-reverse-rgb"]);
const IconSharedWithPublic = ({ style }) => {
  return /* @__PURE__ */ jsx(Tooltip, {
    label: "This item is shared",
    children: /* @__PURE__ */ jsx(ShareIconWrapper, {
      style,
      children: /* @__PURE__ */ jsx(IconGlobe, {
        style: {
          height: "100%",
          width: "100%"
        }
      })
    })
  });
};

export { IconSharedWithPublic };
//# sourceMappingURL=IconSharedWithPublic.js.map
